import { h } from "vue";
import { useModal } from "vue-final-modal";

import ImpersonateModal from "@/components/modals/ImpersonateModal.vue";
import Modal, { type ModalFormat } from "@/components/modals/Modal.vue";

/**
 * Admin-only account impersonation: search an account and mint a token
 * acting on its behalf.
 */
export const openImpersonateModal = () => {
  const { open } = useModal({
    component: Modal,
    attrs: {
      title: "Impersonate",
      subtitle: "Admins only",
      format: "warning" satisfies ModalFormat,
      isCancellable: true,
      showCancelButton: false,
      modalButtons: [],
    },
    slots: { default: () => h(ImpersonateModal) },
  });

  open();
};
